import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAreaLove = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.8809 26.6236C10.1192 23.8107 2.66667 17.3797 2.66667 11.5926C2.66667 7.76751 5.47368 4.66667 9.33333 4.66667C11.3333 4.66667 13.3333 5.33333 16 8C18.6667 5.33333 20.6667 4.66667 22.6667 4.66667C26.5263 4.66667 29.3333 7.76751 29.3333 11.5926C29.3333 17.3797 21.8808 23.8107 18.1191 26.6236C16.8532 27.5701 15.1468 27.5701 13.8809 26.6236Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgAreaLove;
